import { render, staticRenderFns } from "./UserRegistered.vue?vue&type=template&id=16dbc795&scoped=true&"
import script from "./UserRegistered.vue?vue&type=script&lang=js&"
export * from "./UserRegistered.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistered.vue?vue&type=style&index=0&id=16dbc795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dbc795",
  null
  
)

export default component.exports